import * as React from 'react'
import { styled } from '$utils/theme'
import { routeProvider } from '$utils/routeProvider'
import { Icon } from '$views/components/Icon'
import { Link } from '$views/components/Link'
import history from '$utils/history'
import { userGroupService } from '$utils/services/userGroupService'

const logo = require('$icons/logoFamiliados.svg')

const HeaderLogoStyles = styled.div.attrs({})`
  display: inline-flex;
  flex-grow: 1;
  ${p =>
    p.theme.media.onlyMobile`
      padding-left: 0;
      img {
        height: 21px;
        padding-top: 4px;
      }
    `};
  ${p =>
    p.theme.media.desktop`
      margin-top: 6px;
      img {
        transform: scale(1);
      }
    `};
`
interface WindowWithNativeProps extends Window {
  ReactNativeWebView?: any
}

export const HeaderLogo: React.SFC<Props> = () => {
  const redirectOnClickLogo = () => {
    const windowsWithNativeProps: WindowWithNativeProps = window
    if (windowsWithNativeProps.ReactNativeWebView) {
      if (userGroupService.isNormalCustomer()) {
        history.push(routeProvider.myUserArea)
      }
      if (userGroupService.isCaretaker()) {
        history.push(routeProvider.myServices)
      }
    } else {
      history.push(routeProvider.mainPage)
    }
  }

  return (
    <HeaderLogoStyles>
      <Link href="#" onClick={redirectOnClickLogo} title="Familiados">
        <Icon content={logo} logo color="darkGrey" />
      </Link>
    </HeaderLogoStyles>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Layout/FirstLevelHeader/components/HeaderLogo.tsx